module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/mtotal1-997817059ac8ace90510fa95624c363b.jpg";